import { FolderTree, Settings2 } from "lucide-react";
import { Tabs } from "@shared/ui/tabs";
import { ServiceCategoriesTab } from "./serviceCategoriesTab";
import { ServiceConfigurationTab } from "./serviceConfigurationTab";

export function ServicesSettings() {
  const tabComponents = {
    categories: {
      label: "Categories",
      shortLabel: "Categories",
      icon: <FolderTree size={16} />,
      component: <ServiceCategoriesTab />,
    },
    configuration: {
      label: "Service Configuration",
      shortLabel: "Config",
      icon: <Settings2 size={16} />,
      component: <ServiceConfigurationTab />,
    }
  };

  const urlMapping = {
    categories: "categories",
    configuration: "config"
  };

  return (
    <div className="space-y-6">
      <Tabs
        defaultValue="categories"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        idPrefix="services-sub-tab"
        className="w-full"
        level={1}
      />
    </div>
  );
}